"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiSigProposalsQuery = exports.multiSigProposalVotesQuery = exports.multiSigProposalQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get MultiSig proposal details for a given MultiSig address and portfolio ID
 */
function multiSigProposalQuery(paddedIds, variables) {
    const orderBy = paddedIds
        ? `${types_1.MultiSigProposalVotesOrderBy.CreatedBlockIdAsc}, ${types_1.MultiSigProposalVotesOrderBy.EventIdxAsc}`
        : `${types_1.MultiSigProposalVotesOrderBy.CreatedAtAsc}, ${types_1.MultiSigProposalVotesOrderBy.CreatedBlockIdAsc}, ${types_1.MultiSigProposalVotesOrderBy.EventIdxAsc}`;
    const query = (0, graphql_tag_1.default) `
    query MultiSigProposalQuery($multisigId: String!, $proposalId: Int!) {
      multiSigProposals(
        filter: { multisigId: { equalTo: $multisigId }, proposalId: { equalTo: $proposalId } }
      ) {
        nodes {
          eventIdx
          creatorId
          creatorAccount
          createdBlock {
            blockId
            hash
            datetime
          }
          votes(orderBy: [${orderBy}]) {
            nodes {
              action
              signer {
                signerType
                signerValue
              }
            }
          }
          updatedBlock {
            blockId
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.multiSigProposalQuery = multiSigProposalQuery;
/**
 * @hidden
 *
 * Get MultiSig proposal votes for a given proposalId ({multiSigAddress}/{proposalId})
 */
function multiSigProposalVotesQuery(paddedIds, variables) {
    const orderBy = paddedIds
        ? `${types_1.MultiSigProposalVotesOrderBy.CreatedBlockIdAsc}, ${types_1.MultiSigProposalVotesOrderBy.EventIdxAsc}`
        : `${types_1.MultiSigProposalVotesOrderBy.CreatedAtAsc}, ${types_1.MultiSigProposalVotesOrderBy.CreatedBlockIdAsc}, ${types_1.MultiSigProposalVotesOrderBy.EventIdxAsc}`;
    const query = (0, graphql_tag_1.default) `
    query MultiSigProposalVotesQuery($proposalId: String!) {
      multiSigProposalVotes(
        filter: { proposalId: { equalTo: $proposalId } }
        orderBy: [${orderBy}]
      ) {
        nodes {
          signer {
            signerType
            signerValue
          }
          action
          eventIdx
          createdBlockId
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.multiSigProposalVotesQuery = multiSigProposalVotesQuery;
/**
 * @hidden
 *
 * Get MultiSig Proposals history for a given MultiSig address
 */
function multiSigProposalsQuery(multisigId, size, start) {
    const query = (0, graphql_tag_1.default) `
    query MultiSigProposalsQuery($size: Int, $start: Int, $multisigId: String!) {
      multiSigProposals(
        filter: { multisigId: { equalTo: $multisigId } }
        first: $size
        offset: $start
      ) {
        nodes {
          id
          proposalId
          multisigId
          status
          approvalCount
          rejectionCount
          params
        }
        totalCount
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, (0, common_1.getSizeAndOffset)(size, start)), { multisigId }),
    };
}
exports.multiSigProposalsQuery = multiSigProposalsQuery;
//# sourceMappingURL=multisigs.js.map